import { gql } from '@apollo/client';

// Fragment for critical event fields
export const CRITICAL_EVENT_FIELDS = gql`
  fragment CriticalEventFields on DocumentCriticalEvent {
    id
    eventType
    eventDate
    eventLabel
    status
    document {
      id
      title
      status
    }
    deal {
      id
      title
    }
    actorContext
    actionContext
    financialContext
    partyContext
    supportingBlurb
    sourceSection
    sourcePage
    sourceSnippet
    derivationRule
  }
`;

// Query to get critical events by team
export const GET_CRITICAL_EVENTS_BY_TEAM = gql`
  ${CRITICAL_EVENT_FIELDS}
  query GetCriticalEventsByTeam($teamId: ID!, $startDate: String, $endDate: String, $documentType: String) {
    criticalEventsByTeam(teamId: $teamId, startDate: $startDate, endDate: $endDate, documentType: $documentType) {
      ...CriticalEventFields
    }
  }
`;

// Query to get critical events by deal
export const GET_CRITICAL_EVENTS_BY_DEAL = gql`
  ${CRITICAL_EVENT_FIELDS}
  query GetCriticalEventsByDeal($dealId: ID!, $includePast: Boolean, $documentType: String) {
    getCriticalEventsByDeal(dealId: $dealId, includePast: $includePast, documentType: $documentType) {
      ...CriticalEventFields
    }
  }
`;

// Query to get related events for a document
export const GET_DOCUMENT_CRITICAL_EVENTS = gql`
  ${CRITICAL_EVENT_FIELDS}
  query GetDocumentCriticalEvents($documentId: ID!) {
    getCriticalEventsByDocument(documentId: $documentId) {
      ...CriticalEventFields
    }
  }
`;

// Mutation to mark events as completed
export const MARK_CRITICAL_EVENTS_COMPLETED = gql`
  mutation MarkCriticalEventsCompleted($eventIds: [ID!]!) {
    markCriticalEventsCompleted(eventIds: $eventIds) {
      success
      events {
        id
        status
      }
    }
  }
`;

// Mutation to mark events as incomplete
export const MARK_CRITICAL_EVENTS_INCOMPLETE = gql`
  mutation MarkCriticalEventsIncomplete($eventIds: [ID!]!) {
    markCriticalEventsIncomplete(eventIds: $eventIds) {
      success
      events {
        id
        status
      }
    }
  }
`;